<template>
    <div class="enterExamDialog">
        <div style="text-align: center">
          <div style="padding-top: 20px">
            <span style="font-weight: bold; font-size: 20px">考试时间到后，请点击进入考试按钮，进入考试答题界面</span>
          </div>
          <div style="padding-top: 20px">
            <span style="font-size: 14px">如果无法打开，请确认是否安装插件xtaddin_v1.1，点击下载：
              <el-link type="primary" href="/uploadfile/xtaddin_v1.1.rar">xtaddin_v1.1.rar</el-link>
            </span>
          </div>
          <div v-if="!examInfo.isExamPeo" style="padding-top: 20px">
            <el-button type="info" disabled>您不是本次考试人员，不能参加考试</el-button>
          </div>
          <div v-else-if="examInfo.isSubmit" style="padding-top: 20px">
            <el-button type="info" disabled>您已考过，不能重复考试</el-button>
          </div>
          <div v-else style="padding-top: 20px">
            <el-button v-if="examStatusStart == false && examStatusEnd==true" type="info" disabled>考试未开始</el-button>
            <el-button v-if="examStatusStart == true && examStatusEnd==true" type="danger" @click="EnterPaper()">进入考试</el-button>
            <el-button v-if="examStatusEnd == false" type="info" disabled>考试已结束</el-button>
          </div>
          <div
            style="
              margin-top: 20px;
              padding-top: 20px;
              border-top: 1px dashed gray;
            "
          >
            <span>当前时间：</span>
            <span style="color: red">{{ date }} {{time}}</span>
          </div>
          <div style="padding-top: 20px">
            <span>当前IP：</span>
            <span style="color: #8fd57c">{{examInfo.currentIp}}</span>
          </div>
          <div style="padding-top: 20px;font-weight: 700; font-size: 24px;">
            <span>本次考试：{{titleExam}}</span>
          </div>
          <div style="padding-top: 20px">
            <span>
              考试时间：{{ ExamDetail.beginTime }}
            </span>
            <span class="time-line">~</span>
            <span>{{ExamDetail.endTime}}</span>
          </div>
        </div>
    </div>
</template>

<script>
import {
  SelectPaperQuestion,
  SelectPaperDetail,
  SelectPointExam,
  EnterPaper,
  SelectQuestion,
} from '../../../api/exam/paper';
import * as Exam from '@/api/exam/exam'

export default {
  props:['titleExam'],
  data(){
    return{
      paperId: localStorage.getItem('paperId'),
      Ids: localStorage.getItem('Id'),
      enterPaperId:0,//进入考试时的id
      examId:0,//考试id
      userId: this.$store.state.User.ids,//用户id
      examStatusStart: true,
      examStatusEnd: true,
      date: '',
      time:'',
      week:null,
      ExamDetail:[],
      examInfo:{},
      nowTime:'',//现在的时间
      urlA:'',

    }
  },
  methods:{
    //查询考试信息
    getexam() {
      let para = {
        id: this.Ids,
      };
      SelectPointExam(para).then((res) => {
        this.ExamDetail = res.result;
      });
    },
    //进入考试页面
    EnterPaper() {
      let para = {
        examId: parseInt(this.Ids),
        userId: this.userId,
      };
      Exam.getShiCaoUrl(para).then((res)=>{
        this.urlA=res.result
        window.location.href=this.urlA
        this.$emit('closePraDialog')
      })
    },
    //获取当前年月日
    updateTime() {
      this.week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      let cd = new Date();
      this.nowTime=cd
      this.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2);
      this.date = this.zeroPadding(cd.getFullYear(), 4) + '-' + this.zeroPadding(cd.getMonth()+1, 2) + '-' + this.zeroPadding(cd.getDate(), 2) + ' ' + this.week[cd.getDay()];
      let endTime = new Date(this.ExamDetail.endTime);
      if (cd > endTime) {
        this.examStatusEnd = false;
      }
      let beginTime = new Date(this.ExamDetail.beginTime);
      if (cd < beginTime) {
        this.examStatusStart = false;
      }
    },
    zeroPadding(num, digit) {
        var zero = '';
        for(var i = 0; i < digit; i++) {
            zero += '0';
        }
        return (zero + num).slice(-digit);
    },
    //是否已经考试
    getExamUserInfo(){
      
      let para={
        userId:this.userId,
        examId:parseInt(this.Ids)
      }
      debugger
      Exam.getExamProcessInfo(para).then((res)=>{
        
        this.examInfo=res.result
      })
    },
  },
  created(){
    this.getexam()
    this.getExamUserInfo()
    
  },
  mounted(){
    setInterval(this.updateTime, 1000);
  },
  watch:{
    nowTime(newValue){
      let beginTime = new Date(this.ExamDetail.beginTime);
      if(newValue>=beginTime){
        this.examStatusStart = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .enterExamDialog{
    // width: 60%;
    background-color: gainsboro;
    margin: 20px auto;
    padding: 50px;
    font-size: 18px;
  }
  .time-line{
    padding: 0 5px;
  }
</style>